export default "__VITE_ASSET__B0PjV7Pj__"